"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressSpinnerColor = exports.ProgressSpinnerSize = exports.ProgressSpinnerStatus = void 0;
var ProgressSpinnerStatus;
(function (ProgressSpinnerStatus) {
    ProgressSpinnerStatus["Pending"] = "Pending";
    ProgressSpinnerStatus["Success"] = "Success";
    ProgressSpinnerStatus["Failure"] = "Failure";
})(ProgressSpinnerStatus = exports.ProgressSpinnerStatus || (exports.ProgressSpinnerStatus = {}));
var ProgressSpinnerSize;
(function (ProgressSpinnerSize) {
    ProgressSpinnerSize["Small"] = "Small";
    ProgressSpinnerSize["Medium"] = "Medium";
})(ProgressSpinnerSize = exports.ProgressSpinnerSize || (exports.ProgressSpinnerSize = {}));
var ProgressSpinnerColor;
(function (ProgressSpinnerColor) {
    ProgressSpinnerColor["DigitalBlack"] = "digital-black";
    ProgressSpinnerColor["ThemePrimary"] = "themePrimary";
    ProgressSpinnerColor["ThemeSecondary"] = "themeSecondary";
    ProgressSpinnerColor["ThemeTertiary"] = "themeTertiary";
})(ProgressSpinnerColor = exports.ProgressSpinnerColor || (exports.ProgressSpinnerColor = {}));
//# sourceMappingURL=ProgressSpinner.types.js.map